import React, { useEffect, useState } from "react";
import { VILLAGES } from "../../../constants/constants";
import "./VillageList.css";
import { CaretRightOutlined, CaretLeftOutlined } from "@ant-design/icons";
function VillageList({ store }) {
  const [villages, setVillages] = useState([]);
  const [villageBlockNum, setVillageBlockNum] = useState(0);
  const [villageLastBlock, setVillageLastBlock] = useState(0);
  const [villageBlock, setVillageBlock] = useState([]);
  let showNVillages = 2;

  useEffect(() => {
    const villages = VILLAGES.filter((v) => store[v.value] === true);
    setVillages(villages);
    const lastBlock =
      Math.floor(villages.length / showNVillages) +
      (villages.length % showNVillages > 0 ? 1 : 0) -
      1;
    setVillageLastBlock(lastBlock);
  }, [store]);

  useEffect(() => {
    const villageBlock = villages.slice(
      villageBlockNum * showNVillages,
      (villageBlockNum + 1) * showNVillages
    );
    setVillageBlock(villageBlock);
  }, [villages, villageBlockNum]);

  return (
    <div className="ahp-village-list">
      {villageBlock.map((v, index) => {
        return (
          <div
            key={index}
            style={{
              // display: "inline",
              padding: "0px 6px",
              // borderRadius: "10px",
              textTransform: "uppercase",
              width: "max-content",
              fontSize: "12px",
            }}
          >
            {v.label}
          </div>
        );
      })}
      {villageLastBlock > 0 && villageBlockNum < villageLastBlock && (
        <CaretRightOutlined
          style={{ position: "absolute", right: 10, top: 1 }}
          onClick={() => setVillageBlockNum(villageBlockNum + 1)}
        />
      )}
      {villageBlockNum > 0 && villageBlockNum <= villageLastBlock && (
        <CaretLeftOutlined
          style={{ position: "absolute", left: 10, top: 1 }}
          onClick={() => setVillageBlockNum(villageBlockNum - 1)}
        />
      )}
    </div>
  );
}

export default VillageList;
